import { useAtom } from "jotai";
import React from "react";
import { BLOCK_TYPE_ICONS, BLOCK_TYPE_LABELS } from "../blocks/MenuBlock";
import Icon from "../components/Icon";
import { ListMenu, ListMenuIconItem, ListMenuItem } from "../components/Menu";
import { currentUserAtom } from "../jotai/atoms";
import { useFeatureFlags } from "../liveblocks/maps";
import { usePresence } from "../liveblocks/presences";
import { styled } from "../stitches.config";
import { ContextMenu, FeatureFlags, User } from "../types";
import { BLOCK_MENU_ITEMS, iconStyle } from "../ui/SpaceContextMenu";

export function ContextMenuList() {
  const [contextMenus] = usePresence<ContextMenu>("contextMenu");
  const [currentUser] = useAtom(currentUserAtom);
  const [featureFlags] = useFeatureFlags();

  const menuList = Object.entries(contextMenus).filter(
    ([userId, menu]) => menu && userId !== currentUser?.id
  ) as [User["id"], ContextMenu][];

  return (
    <div>
      {menuList.map(([userId, menu]) => {
        return menu.type === "space" ? (
          <SpaceMenu key={userId} menu={menu} featureFlags={featureFlags} />
        ) : (
          <BlockMenu key={userId} menu={menu} />
        );
      })}
    </div>
  );
}

const SpaceMenu = React.memo(function SpaceMenu({
  menu,
  featureFlags,
}: {
  menu: ContextMenu;
  featureFlags?: FeatureFlags;
}) {
  let items = [...BLOCK_MENU_ITEMS];

  if (!featureFlags?.webBlock) {
    items = items.filter((t) => t !== "web");
  }

  return (
    <Menu
      style={{
        left: (menu.position.x || 0) + 1,
        top: menu.position.y,
      }}
    >
      {items.map((item, i) => {
        const icon = BLOCK_TYPE_ICONS[item];
        return (
          <ListMenuIconItem key={i} hover={menu.hoverIndex == i}>
            {icon ? <Icon style={iconStyle} icon={icon} /> : null}
            {BLOCK_TYPE_LABELS[item]}
          </ListMenuIconItem>
        );
      })}
    </Menu>
  );
});

const BlockMenu = React.memo(function BlockMenu({
  menu,
}: {
  menu: ContextMenu;
}) {
  const items = [
    "Delete",
    "Duplicate",
    "Send To Back",
    "Style Block",
    "Toggle Lock",
  ];

  return (
    <Menu
      style={{
        left: (menu.position.x || 0) + 1,
        top: menu.position.y,
      }}
    >
      {items.map((item, i) => (
        <ListMenuItem key={i} hover={menu.hoverIndex == i}>
          {item}
        </ListMenuItem>
      ))}
    </Menu>
  );
});

const Menu = styled(ListMenu, {
  position: "absolute",
  zIndex: "$contextMenu",
});
